import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../components/global/Button';
import usePurchasesPendingConfiguration from '../../../../../apps/pro/views/HierarchyItem/Matches/components/PurchasesPendingConfiguration/hooks/usePurchasesPendingConfiguration';
import PurchasesPendingConfiguration from '../../../../../apps/pro/views/HierarchyItem/Matches/components/PurchasesPendingConfiguration/PurchasesPendingConfiguration';

const propTypes = {
  hierarchyItemId: PropTypes.string.isRequired,
  watermarkSettings: PropTypes.shape({
    wallpaperCustomText: PropTypes.string,
    wallpaperFontSize: PropTypes.number,
  }),
};

const CheckoutCartPendingPurchases = ({
  hierarchyItemId,
  watermarkSettings,
}) => {
  const [configuring, setConfiguring] = useState(false);

  const {
    prepaidPrintPackagesMissingConfiguration,
    prepaidPhotoPricingsMissingConfiguration,
    prepaidCustomPrintsMissingConfiguration,
  } = usePurchasesPendingConfiguration({
    hierarchyItemId,
    shippableOnly: true,
  });

  const itemsMissingConfigurationTotal =
    (prepaidPrintPackagesMissingConfiguration?.length ?? 0) +
    (prepaidPhotoPricingsMissingConfiguration?.length ?? 0) +
    (prepaidCustomPrintsMissingConfiguration?.length ?? 0);

  useEffect(() => {
    if (itemsMissingConfigurationTotal === 0) {
      setConfiguring(false);
    }
  }, [itemsMissingConfigurationTotal]);

  if (itemsMissingConfigurationTotal === 0) {
    return null;
  }

  return (
    <div className="prepaid-items-missing-configuration-warning">
      {itemsMissingConfigurationTotal > 0 && (
        <Fragment>
          <p className="text-sm">
            All pre-purchased prints &amp; products must be configured before
            proceeding to checkout. Configure your remaining purchases (
            {itemsMissingConfigurationTotal}) to continue.
          </p>

          <Button
            btnStyle="white"
            btnOutline
            btnSize="sm"
            pill
            className="text-bold"
            onClick={() => setConfiguring(prev => !prev)}
          >
            Configure now
          </Button>
          {configuring && (
            <div className="checkout-pending-purchases-overlay">
              <PurchasesPendingConfiguration
                startExpanded
                shippableOnly
                hierarchyItemId={hierarchyItemId}
                className="checkout-pending-purchases-collapsable"
                onExpand={() => setConfiguring(false)}
                onCheckout={() => setConfiguring(false)}
                optionProps={{
                  onConfigurationComplete: null,
                }}
                watermarkSettings={watermarkSettings}
              />
            </div>
          )}
        </Fragment>
      )}
    </div>
  );
};

CheckoutCartPendingPurchases.propTypes = propTypes;

export default CheckoutCartPendingPurchases;
